import { TranslationsTypes } from '@/lib/i18n/i18n.client';

import {
  DropdownOption,
  InputDropdownProps,
} from '@/components/atoms/InputDropdown/index';

export function getSelectedDisplayValue<T extends DropdownOption>({
  value,
  renderSelectedValue,
  options,
  placeholder,
  texts,
}: Pick<
  InputDropdownProps<T>,
  'value' | 'renderSelectedValue' | 'options' | 'placeholder'
> & { texts: TranslationsTypes }) {
  if (value && renderSelectedValue) {
    return renderSelectedValue({
      option: options.find((option) => option.value === value) as T,
    });
  }
  if (value) {
    return options.find((option) => option.value === value)?.label || value;
  }
  if (placeholder) {
    return placeholder;
  }

  return texts.input_dropdown.dropdown_placeholder;
}
